export const GROUP_TYPE_MEMBER = 'Community';
export const GROUP_TYPE_ROLE = 'role';
export const GROUP_TYPE_BADGE = 'badge';
export const GROUP_TYPE_BADGE_WITH_PERMISSION = 'badge_with_permissions';
export const GROUP_TYPE_PAID_PLAN = 'plan';
